import config from "./config";

function Jarvis() {
  this.redeemDelegate = function (delegateToken, appState) {
    var redeemTokenPromise = $.Deferred();
    $.ajax({
      url:
        NVIDIAGDC.Accounts.accountsJarvisSrvcBase +
        config.JARVIS_DELEGATE_REDEEM,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        clientId: config.CLIENT_ID,
        clientDescription: config.CLIENT_DESCRIPTION,
        deviceId: config.DEVICE_ID,
      }),
      headers: {
        authorization: "Basic " + window.btoa(delegateToken + ":"),
      },
      success: function (data) {
        redeemTokenPromise.resolve(data);
      },
      error: function (jqXHR) {
        redeemTokenPromise.reject({ userId: "" });
      },
    });
    return redeemTokenPromise;
  };
}

export default Jarvis;
